/* global axios */

// custom: T7 — API client para favoritas de conversa por agente.
// Endpoints fornecidos pelo PR1 (engine cw_custom).
const accountBase = accountId => `/api/v1/accounts/${accountId}/cw_custom`;

export default {
  // GET → { conversation_ids: [Int] } — ids das conversas favoritadas pelo agente atual.
  index(accountId) {
    return axios.get(`${accountBase(accountId)}/conversation_favorites`);
  },

  // POST { conversation_id } → { conversation_id, favorited: bool }
  // Idempotente: cria se ausente, remove se presente.
  toggle(accountId, conversationId) {
    return axios.post(
      `${accountBase(accountId)}/conversation_favorites/toggle`,
      { conversation_id: conversationId }
    );
  },
};
